var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalHoldDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      fillOpacity: 1,
      strokeWidth: 1.56264
    },
    fill: "#ad3f16",
    d: "M11.676 43.019 29.474 23.24l-2.21-2.21-19.776 17.8a2.965 2.965 0 0 0-.113 4.3 2.964 2.964 0 0 0 4.3-.112z",
    transform: "translate(-2.506)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404040",
      fillOpacity: 1,
      strokeWidth: 1.56264
    },
    fill: "#751b0b",
    transform: "matrix(-.70708 -.70713 -.7071 .7071 -2.506 0)",
    d: "M-45.146-16.909h18.808V-5.08h-18.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      fillOpacity: 1,
      strokeWidth: 1.56264
    },
    fill: "#d6742d",
    d: "m33.344 26.132 8.368-8.368c.6-.6.6-1.572 0-2.172L34.979 8.86c-.6-.6-1.572-.6-2.172 0l-8.368 8.368c-.6.6-.6 1.572 0 2.172l6.733 6.733c.6.6 1.572.6 2.172 0zM22.248 14.998l8.33-8.33c.611-.611.611-1.6 0-2.21a1.56 1.56 0 0 0-2.21 0l-8.33 8.33a1.564 1.564 0 0 0 2.21 2.21zm15.47 15.469 8.33-8.33c.611-.611.611-1.6 0-2.21a1.56 1.56 0 0 0-2.21 0l-8.33 8.33a1.561 1.561 0 0 0 0 2.21 1.56 1.56 0 0 0 2.21 0z",
    transform: "translate(-2.506)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13 10.972 5.972 7.13a1.499 1.499 0 0 1 2.119 0L9.9 8.94 3.94 14.9l-1.81-1.807a1.503 1.503 0 0 1 0-2.122",
    fill: "#e57373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.92 17.88 26.802 26.802 5.963-5.963-26.801-26.801Z",
    fill: "#ff9800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.884 11.924 9.904 8.94 3.935 14.9l2.98 2.983z",
    fill: "#b0bec5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m39.685 38.72 2.006 7.971-7.97-2.007Z",
    fill: "#ffc107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40.675 42.66 1.016 4.031-4.03-1.018Z",
    fill: "#37474f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalHoldDraft);
export default __webpack_public_path__ + "static/media/legalHoldDraft.f498ce762b5e15625bebde6d9a330f3a.svg";
export { ForwardRef as ReactComponent };